<script setup lang="ts">
  import {
    computed,
    ref,
    type ComputedRef,
  } from 'vue'
  
  import { useI18n } from 'vue-i18n'

  import { useSubject } from '@/composables/useSubject'
  import { IbexaContentTypeIdentifier } from '@/enums/IbexaContentTypeIdentifier'
  import type { AnchorNavigationPage } from '@/types/AnchorNavigationPage'
  import type { IbexaImageField } from '@/types/Ibexa'

  import AnchorNavigationTemplate from '@/components/anchor-navigation/AnchorNavigationTemplate.vue'
  import VgsSpinner from '@/components/common/VgsSpinner.vue'

  const { t } = useI18n()
  const { subject, subjectGuide } = useSubject()

  const content: ComputedRef<AnchorNavigationPage> = computed(() => ({
    description: subjectGuide.value?.introduction ?? '',
    image: subjectGuide.value?.image ?? {} as IbexaImageField,
    sections: [subjectGuide.value?.description ?? ''],
    sectionTitles: [''],
    contentId: subjectGuide.value?.contentId ?? 0,
    locationId: subjectGuide.value?.locationId ?? '',
    parentLocationId: subjectGuide.value?.parentLocationId ?? '',
    title: subjectGuide.value?.title ?? '',
    contentTypeIdentifier: IbexaContentTypeIdentifier.vgsSubjectResource,
    pathString: subjectGuide.value?.pathString ?? '',
    isTeacherOnly: subjectGuide.value?.isTeacherOnly ?? false,
    depth: subjectGuide.value?.depth ?? 0,
  }))

  const isLoading = ref<boolean>(false)
</script>

<template>
  <VgsSpinner :is-loading="isLoading" />
  <AnchorNavigationTemplate
    v-if="subjectGuide"
    :content="content"
    :top-section-title="t('subject.to-teacher')"
    :top-section-super-title="subject?.title"
  />
</template>
